export default __webpack_public_path__ + "static/media/1993.f20476b4.jpg";